/**
 * Where the dashboard sends a user who has to ask someone about Credits or a purchase: the wallet
 * cannot be topped up here, it is frozen, the account is not set up for buying, or a run is short.
 * One address for all of it, kept here so every page says the same one.
 */
export const SALES_EMAIL = "sales@integrisiq.com";

/** `SALES_EMAIL` as a link target. */
export const SALES_MAILTO = `mailto:${SALES_EMAIL}`;
